import { put, call, takeEvery } from 'redux-saga/effects';
import { axiosInstance, apiURL } from 'config';
import toast from 'react-hot-toast';

import {
  loadCouponsRequested,
  loadCouponsSuccess,
  loadCouponsFail,
  storeCouponSuccess,
  storeCouponFail,
  storeCouponRequested,
  updateCouponRequested,
  updateCouponSuccess,
  updateCouponFail,
  assignCouponRequested,
  assignCouponSuccess,
  assignCouponFail,
  deleteCouponSuccess,
  deleteCouponFail,
  deleteCouponRequested,
} from './couponSlice';

export function* loadCouponsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/index-coupon?searchString=${
        action?.payload?.filters?.query ?? ''
      }&page=${action.payload.page}&pageSize=${action.payload.perPage}`,
      action.payload
    );
    yield put(loadCouponsSuccess(data));
  } catch (error: any) {
    yield put(loadCouponsFail(error.message));
  }
}

export function* storeCouponEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/create-coupon`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(storeCouponSuccess(data));
      toast.success('coupon created successfully');
    } else {
      toast.error('Coupon create failed! ', data?.errors);
    }
  } catch (error: any) {
    yield put(storeCouponFail(error.message));
  }
}

export function* assignCouponEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/assign-coupon`,
      action.payload
    );

    if (data?.succeeded) {
      yield put(assignCouponSuccess(data));

      toast.success('assign coupon successfully');
    } else {
      toast.error('assign coupon failed! ', data?.errors);
    }
  } catch (error: any) {
    yield put(assignCouponFail(error.message));
  }
}

export function* updateCouponEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.put,
      `${apiURL}/edit-coupon`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(updateCouponSuccess(data));

      toast.success('Offer updated successfully');
    } else {
      toast.error('Offer update failed! ', data?.errors);
    }
  } catch (error: any) {
    yield put(updateCouponFail(error.message));
  }
}

export function* deleteCouponEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/delete-coupon?Id=${action.payload?.item?.id}`,
      action.payload
    );

    if (data?.succeeded) {
      yield put(deleteCouponSuccess(data));
      toast.success('Coupon deleted successfully');
    } else {
      toast.error('Coupon delete failed!', data?.errors);
    }
  } catch (error: any) {
    yield put(deleteCouponFail(error.message));
  }
}

export function* couponsSaga(): Generator<any, void, any> {
  yield takeEvery(loadCouponsRequested, loadCouponsEffect);
  yield takeEvery(storeCouponRequested, storeCouponEffect);
  yield takeEvery(updateCouponRequested, updateCouponEffect);
  yield takeEvery(assignCouponRequested, assignCouponEffect);
  yield takeEvery(deleteCouponRequested, deleteCouponEffect);
}
